module.exports = import("https://esm.sh/@tiptap/extension-heading@2.4.0");;